import { upload } from 'shared/api/services/file-storage';

export async function uploadCode(
  formData: FormData,
  setProgress: (percent: number) => void,
  slug: string
): Promise<string[]> {
  const res = await upload(
    formData,
    `${process.env.API_URL}/git/${slug}/files`,
    setProgress
  );

  if (res.status !== 200) throw new Error(`${res.status}`);
  return res.data;
}

export async function uploadData(
  formData: FormData,
  setProgress: (percent: number) => void,
  slug: string
) {
  const endpoint = `${process.env.API_URL}/file-storage/userdata/${slug}/uploadData`;
  const res = await upload(formData, endpoint, setProgress);
  if (res.status !== 200) throw new Error(`${res.status}`);
  return res.data;
}
